import React from 'react';
import type { Maybe } from '@soundxyz/utils/helpers';
import type { SharedImageWrapperProps } from '@components/main-components/image/BaseImage';
import { ImageWrapper, SquareImage } from '@components/main-components/image/BaseImage';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import { ImageViewModal } from '@components/modals/ImageViewModal';
import { ModalContext, ModalType } from '@context/modal';
import { WebWorkerImage } from './WebWorkerImage';

export function Cover({
  src,
  alt,
  size,
  priority = false,
  isAnimated = false,
  ...props
}: {
  src: string;
  alt: string;
  size: number;
  priority?: boolean;
  isAnimated?: boolean;
} & ({ href: Maybe<Pathname> } | { modalOnClick?: boolean }) &
  SharedImageWrapperProps) {
  const { borderRadius = 4, disableLink, hasShadow, hasBorder } = props;
  const { openModal } = ModalContext.useContainer();

  const link = 'href' in props ? props.href : undefined;
  const showModal = 'modalOnClick' in props ? props.modalOnClick : false;
  return (
    <ImageWrapper
      href={link}
      hasShadow={hasShadow}
      hasBorder={hasBorder}
      disableLink={disableLink}
      borderRadius={borderRadius}
      onClick={() => {
        if (showModal) {
          openModal(ModalType.IMAGE_VIEW, {
            body: <ImageViewModal src={src} />,
          });
        }
      }}
      css={{
        flexShrink: 0,
        cursor: !!link || showModal ? 'pointer' : 'unset',
        width: size,
      }}
    >
      {isAnimated ? (
        <WebWorkerImage src={src} width={size} height={size} />
      ) : (
        <SquareImage
          src={src}
          alt={alt}
          size={size}
          priority={priority}
          borderRadius={borderRadius}
        />
      )}
    </ImageWrapper>
  );
}
